export const LOCATION_TITLE_TEXT = "Местоположение";